/**
 * Create a random string ID
 * @param length - Length of the id
 * @param except - Id's that should not be generated
 */
export function makeId(length: number, except: string[] = []): string {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    if (except.includes(result)) {
        return makeId(length, except);
    } else {
        return result;
    }
}

/**
 * Get's the filename of a given path
 * @param path
 * @param withExtension - print with extension (default false)
 */
export const getFilename = (path: string, withExtension = false) =>
    path.split('~')[1].replace(!withExtension ? /(\.).*/ : '', '');

/**
 * Map for multi requirements (like alls files from a folder)
 * @param folder - e.g. "./assets"
 * @param mimeTypes - default is all images: /\.(png|jpe?g|gif)$/
 */
export function importAll(
    folder: string,
    mimeTypes = /\.(png|jpe?g|gif)$/
): { path: string; name: string; id: number }[] {
    const r = (require as any).context(folder, false, mimeTypes);
    return r
        .keys()
        .map(r)
        .map((data: { default: string }, id: number) => ({
            path: data.default,
            id,
            name: getFilename(data.default)
        }));
}

/**
 * Get a random number between two numbers. Ability to exclude a number and round
 * @param min
 * @param max
 * @param round
 * @param except
 */
export const randomBetween = (min: number, max: number, round = false, except?: number | number[]): number => {
    const random = round
        ? Math.floor(Math.random() * (max - min + 1) + min)
        : Math.floor(Math.random() * (max - min + 1) + min);
    if (except) {
        if (Array.isArray(except)) {
            return !except.includes(random) ? random : randomBetween(min, max, round, except);
        } else {
            return random !== except ? random : randomBetween(min, max, round, except);
        }
    } else {
        return random;
    }
};

/**
 * Capitalize word (First letter is capital)
 * @param word
 */
export const capitalize = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export const isEnglish = () => location.pathname.includes('/en');

export const changeLang = () => {
    if (isEnglish()) {
        window.location.href = window.location.href.replace('/en', '');
    } else {
        const url = window.location.href.replace(/([a-zA-Z0-9\s_\\.\-\(\):])+(.html)$/, '');
        let suffix = 'en';
        if (url[url.length - 1] !== '/') {
            suffix = '/' + suffix;
        }
        window.location.href = url + suffix;
    }
};

export const getPageWidth = () => {
    const boundingBox = document.body.getBoundingClientRect();
    return boundingBox.width;
};

export const getNavbarHeight = (
    sizes: { [key: number]: { breakpoint: string; height: string } },
    pageWidth: number
) => {
    return Object.values(sizes).reduce((acc, obj) => (pageWidth > parseInt(obj.breakpoint) ? obj : acc))['height'];
};

/**
 * Array.map function for objects
 * @param object - Object to map through
 * @param mapFn - Classic map function
 */
export const mapObj = <T extends { [key: string]: any }>(
    object: T,
    mapFn: (key: string, value: T[keyof T]) => T[keyof T]
): T =>
    Object.keys(object).reduce(function(result, key) {
        (result as { [key: string]: any })[key] = mapFn(key, object[key]);
        return result;
    }, {} as T);
